import { GENERAL } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { injectable } from "tsyringe";
import { DataFormat } from "utils/format/DataFormat";
import { StringFormat } from "utils/format/StringFormat";
import { getMessage } from "utils/helpersInTs/helpersInTs";
import { IGeneralRepository } from "../domain/repositories/IGeneralRepository";
import { GeneralResponseModel } from "./model/GeneralResponseModel";
import { TransactionDetailReportRequestModel } from "./model/TransactionDetailReportRequestModel";
import { TransactionDetailReportResponseModel } from "./model/TransactionDetailReportResponseModel";
import { TransactionReportRequestModel } from "./model/TransactionReportRequestModel";
import { TransactionReportResponseModel } from "./model/TransactionReportResponseModel";

@injectable()
export class GeneralImpl implements IGeneralRepository {
  async getGeneralData(): Promise<
    ListBaseApiResponseModel<GeneralResponseModel>
  > {
    return await client?.get(GENERAL.GENERAL_DATA);
  }

  async getTransactionReport(
    params: TransactionReportRequestModel,
  ): Promise<ListBaseApiResponseModel<TransactionReportResponseModel>> {
    const url = StringFormat.buildListUrl<TransactionReportRequestModel>(
      GENERAL.TRANSACTION_REPORT,
      params,
    );
    const preparedParams = DataFormat.prepareParamsForApi(params);
    return await client.get(url, preparedParams);
  }

  async getTransactionDetailReport(
    params: TransactionDetailReportRequestModel,
  ): Promise<ListBaseApiResponseModel<TransactionDetailReportResponseModel>> {
    const url = StringFormat.buildListUrl<TransactionDetailReportRequestModel>(
      GENERAL.TRANSACTION_DETAIL_REPORT,
      params,
    );
    const preparedParams = DataFormat.prepareParamsForApi(params);
    return await client.get(url, preparedParams);
  }

  async exportTransactionDetailReport(
    params: TransactionDetailReportRequestModel,
  ): Promise<BaseApiResponseModel<Blob>> {
    const url = StringFormat.buildExportUrl(
      GENERAL.TRANSACTION_DETAIL_REPORT,
      params,
    );
    const token = DataFormat.getToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorBody = await response.json();
      getMessage(errorBody["message"], 3, "error");
      return errorBody;
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }
}
